module.exports = __webpack_public_path__ + "img/comment-minus.19e27f66.svg";